export default "__VITE_ASSET__BVPw05tW__"